export default __webpack_public_path__ + "static/media/gallery_12.85fd902d.jpg";